import { minusOnePx, useMedia, useTheme } from "@catchoftheday/theme";
export var useIsMobile = function useIsMobile() {
  var desktopBreakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "md";
  var theme = useTheme();
  var isMobile = useMedia(["(max-width: ".concat(minusOnePx(theme.breakpoints[desktopBreakpoint], true), ")")], [true]);
  return isMobile;
};